import React from "react";

import { Panel } from "react-bootstrap";
import FormattedAddress from "../../addresses/FormattedAddress";
import { FsdAddressType } from "shared/src/types/customer/FsdAddress";

type Props = {
    address: FsdAddressType;
    clickHandler: any;
    selected: boolean;
    renderInPopover: boolean;
};

function CustomerAddressBadge(props: Props) {
    const address = props.address;
    const mandatoryPanelClasses =
        "test-address-panel test-select-address-button panel-small test-address-" +
        props.address.hash +
        " " +
        (props.renderInPopover ? "flexed-item--auto" : "panel-default");

    const panelClasses = props.selected
        ? "panel-primary background-primary-reduced-more " + mandatoryPanelClasses
        : mandatoryPanelClasses;
    return address ? (
        <Panel className={panelClasses} onClick={props.clickHandler.bind(null, props.address)}>
            <FormattedAddress address={address} />
            <br />
            <p className="small">
                <span className="text-brand">
                    <i className="icon-small-location" />
                    &nbsp;
                    <strong>{address.storeName}</strong>
                </span>
            </p>
        </Panel>
    ) : null;
}

export default CustomerAddressBadge;
